<!--
 * @Description: 券列表弹窗
 * @Author: xd
 * @Date: 2021-11-22 16:34:01
-->
<template>
  <Modal
    class="modal-CouponListModal"
    :name="modalName"
    :show-close="true"
    :cover-closeable="false"
    :close-btn-handler="handleClose"
    @modalClose="handleClose"
  >
    <div
      slot="modal-content"
      class="content"
    >
        <div
          class="tipDownBtn"
        >
        <div  v-for="(item,index) in couponList" :key="index"
        class="listStyle"
        :style="{
          backgroundImage: `url(${item})`,
        }"></div>
        </div>
        <div class="upBackBtn">
          <div class="jumpGasUrlBtn" @click="jumpGasUrl"></div>
          <div class="jumpGasUrlTest">{{`用${myPhone}手机号登录高德app至-我的-钱包卡券-加油卡券`}}</div>
        </div>
      </div>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue';

export default {
  name: 'CouponListModal',
  components: {
    Modal
  },
  props: {
    // 券数据列表
    couponList: {
      type: Array,
    },
    // 弹窗打开状态
    myPhone: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      modalName: 'CouponListModalShow',
    };
  },
  methods: {
    /**
     * 关闭按钮处理
     */
    handleClose() {
      this.$emit('modalHandler', 'modalClose', this.modalName);
    },
    // 领取按钮点击
    jumpGasUrl() {
      this.$emit('jumpGasUrl');
    },
  }
};
</script>

<style lang="scss">
@import "../../css/common-mixin";

.modal-CouponListModal {
  .modal{
    width: rpx(611);
    height: rpx(558);
    top:40%;
    .close{
      top: rpx(700);
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content {
    width: rpx(611);
    height: rpx(558);
    background: url("../../../assets/endPage/coupon-list-back.png") center no-repeat;
    background-size: 100% 100%;
    padding-top: rpx(110);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .tipDownBtn{
      width: rpx(382);
      height: rpx(350);
      overflow-y: scroll;
      // -webkit-overflow-scrolling: touch;
      .listStyle{
        width: rpx(382);
        height: rpx(107);
        background: center no-repeat;
        background-size: 100% 100%;
        margin-bottom: rpx(14);
      }
    }
    .upBackBtn{
      width: rpx(527);
      height: rpx(227);
      background: url("../../../assets/endPage/back-up-btn.png") center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      bottom: rpx(-80);
      left: 50%;
      transform: translateX(-50%);
      .jumpGasUrlBtn{
        width: rpx(440);
        height: rpx(85);
        position: absolute;
        top: rpx(62);
        left: 50%;
        transform: translateX(-50%);
      }
      .jumpGasUrlTest{
        width: rpx(320);
        font-size: rpx(18);
        color: #fef5e3;
        position: absolute;
        top: rpx(160);
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
